export default {
    pages: {
        136: [
            {
                id: 'print', // action_button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: 101 // This value will ensure the print button is displayed over the overlay mask.
                    }
                ]
            }
        ],
        224: [
            {
                id: 'print', // action_button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: 101
                    }
                ]
            }
        ],
        324: [
            {
                id: 'start', // button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: 101 // The button on this page should be disabled, rather than be blocked by an overlay
                    }
                ]
            },
            {
                id: 'stop', // button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: 101 // The button on this page should be disabled, rather than be blocked by an overlay
                    }
                ]
            },
            {
                id: 'answer', // text_node.
                attributes: [
                    {
                        name: 'zIndexOverride',
                        value: 3 // This text node needs to show over the match_field_node's zIndex
                    }
                ]
            },
        ],
        325: [
            {
                id: 'start', // button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: 101 // The button on this page should be disabled, rather than be blocked by an overlay
                    }
                ]
            },
            {
                id: 'stop', // button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: 101 // The button on this page should be disabled, rather than be blocked by an overlay
                    }
                ]
            },
            {
                id: 'answer', // text_node.
                attributes: [
                    {
                        name: 'zIndexOverride',
                        value: 3 // This text node needs to show over the match_field_node's zIndex
                    }
                ]
            },
        ],
        327: [
            {
                id: 'print', // action_button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: 101
                    }
                ]
            }
        ],
        430: [
            {
                id: 'print', // action_button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: 101
                    }
                ]
            }
        ],
        525: [
            {
                id: 'print', // action_button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: 101
                    }
                ]
            }
        ],
        635: [
            {
                id: 'print', // action_button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: 101
                    }
                ]
            }
        ],
    }
};



// WEBPACK FOOTER //
// ./src/js/transformers/MO.INCA.3.0.2.js